import TerrificBridge from 'react-terrific-bridge';

type TerrificProps = {
	children?: any;
};

const Terrific = ({ children }: TerrificProps) => {
	TerrificBridge.configure({ debug: false });
	TerrificBridge.load();

	return children;
};

Terrific.displayName = 'TerrificBridge';

export default Terrific;
